var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6909,
    cy: 20.9995,
    r: 20.5952,
    fill: "#19191B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6909,
    cy: 20.9995,
    r: 20.0952,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1928 28.5046V28.5041H28.1966V22.9295C28.1966 20.2024 27.6095 18.1016 24.4213 18.1016C22.8886 18.1016 21.8601 18.9427 21.4402 19.7399H21.3959V18.3562H18.373V28.5041H21.5208V23.4791C21.5208 22.1562 21.7716 20.8767 23.4099 20.8767C25.0244 20.8767 25.0483 22.3866 25.0483 23.5639V28.5046H28.1928Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2461 18.3574H16.3976V28.5053H13.2461V18.3574Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8214 13.3047C13.8137 13.3047 12.9961 14.1223 12.9961 15.13C12.9961 16.1378 13.8137 16.9724 14.8214 16.9724C15.8292 16.9724 16.6468 16.1378 16.6468 15.13C16.646 14.1223 15.8284 13.3047 14.8214 13.3047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.3d4a577c448d37921da578b7e9284798.svg";
export { ForwardRef as ReactComponent };